export default class BlockProductGallery {

  init() {

    this.thumbnails = new Swiper(this.outlets.thumbnails, {
      slidesPerView: 'auto',
      spaceBetween: 5,
      watchSlidesProgress: true
    });

    this.carousel = new Swiper(this.outlets.carousel, {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: this.outlets.next,
        prevEl: this.outlets.prev
      },
      thumbs: {
        swiper: this.thumbnails
      }
    });

  }
}
